import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Z_INDEX } from '@liveHelper/constants'
import {
  CHAT_HEADER_HEIGHT,
  TRANSITION_CLASSNAMES,
} from '@oneToOne/shared/components/chat/constants'
import type { ChatColorTheme } from '@oneToOne/shared/components/chat/theme/ChatThemeContext'
import { FlexCenter } from '@oneToOne/shared/styles'
import { generateTransitionGroupStyles } from '@oneToOne/shared/utils/generateTransitionGroupStyles'

export const ChatHeaderOnCallWrapper = styled.div<{ theme: ChatColorTheme }>`
  ${FlexCenter}
  position: relative;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 191px;
  border-bottom: 1px solid
    ${({ theme }) =>
      theme === 'light' ? 'var(--gray-4)' : 'var(--cool-gray-800)'};
  background: ${({ theme }) =>
    theme === 'light' ? 'var(--white)' : 'var(--cool-gray-900)'};
  overflow: hidden;
`

export const ActionContainer = styled.div`
  ${FlexCenter}
  position: absolute;
  top: var(--spacing-16);
  right: var(--spacing-16);
  gap: var(--spacing-12);
  z-index: ${Z_INDEX.FLOATING_ACTION};
`

export const Column = styled.div`
  position: relative;
  ${FlexCenter};
  flex-direction: column;
  width: 100%;
  height: ${CHAT_HEADER_HEIGHT.videoContainer}px;
`

export const ButtonRowWrapper = styled.div`
  position: absolute;
  bottom: var(--spacing-16);

  ${generateTransitionGroupStyles({
    className: TRANSITION_CLASSNAMES.VIDEO_CONTROLS_BUTTON_ROW,
    startStyle: css`
      opacity: 0;
      transform: translateY(20px);
    `,
    endStyle: css`
      opacity: 1;
      transform: translateY(0);
    `,
  })}
`
